<template>
  <div class="discussions-page">
    <page-header :breadcrumbs="[]">
      <template v-slot:topbar>
        <h1>{{ currentResource.name }}</h1>
      </template>
    </page-header>
    <loading v-if="loading" />
    <div
      v-else
      class="list-container"
    >
      <template v-if="discussions.length > 0">
        <list-row
          v-for="discussion in sortedDiscussions"
          :key="discussion.id"
          @row-clicked="discussionClicked(discussion)"
        >
          <div class="message">
            {{ discussion.message }}
          </div>
          <icon
            name="arrow"
            class="arrow"
            variant="4fb9de"
          />
        </list-row>
      </template>
      <div
        v-else-if="!loading"
        class="empty-state"
      >
        <p class="heading">
          You haven’t participated in a discussion yet.
        </p>
        <p>We’ll keep track of your comments here so you can quickly return to the conversation.</p>
      </div>
    </div>
  </div>
</template>

<script>
import GlobalMixin from '@/mixins/global';
import Icon from '@components/singletons/icon';
import ListRow from '@components/ui/listRow';
import Loading from '@/components/singletons/loading';
import PageHeader from '@components/singletons/pageHeader';

export default {
  name: 'DiscussionView',
  components: { Icon, ListRow, Loading, PageHeader },
  mixins: [GlobalMixin],
  data() {
    return {
      discussions: [],
      loading: true,
    };
  },
  computed: {
    sortedDiscussions() {
      const discussions = this.discussions;
      discussions.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
      return discussions;
    },
  },
  created() {
    this.$store.dispatch('flashcardStates/fetchStates', ['bookmarks', 'flashcards', 'stats']);

    if (this.$store.getters['session/currentUser']?.bannedFromDiscussions) {
      this.$router.push({ name: 'mastery#home' });
    }
    this.$analytics.events.viewedDiscussionPage();
    this.$store.dispatch('discussions/fetchDiscussions').then(discussions => {
      this.discussions = discussions;
      this.loading = false;
    }).catch(error => {
      this.loading = false;
      return Promise.reject(error);
    });
  },
  methods: {
    discussionClicked(discussion) {
      this.$analytics.events.viewedPreviousDiscussion(discussion);
      this.$router.push({
        name: 'deeplinks#flashcard',
        params: {
          flashcardId: discussion.resourceId,
        },
        query: {
          discussionId: discussion.id,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  .discussions-page, .loading-component-container {
    background: #EDF1F5 !important;
    @include full-padding;
  }

  .message {
    height: rem-calc(16);
    margin-right: auto;
    padding: rem-calc(21) 0;
    position: relative;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .empty-state {
    margin: 0 auto;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: rem-calc(32);

    p {
      margin-top: 0;

      &:last-child {
        margin-bottom: 0;
      }

      &.heading {
        font-weight: $semi-bold;
        margin-bottom: rem-calc(8);
      }
    }
  }
</style>
